import React from 'react'

import ServicesLayout from 'presentation/patient/layouts/ServicesLayout'

export default function Services() {
  return <ServicesLayout />
}
